<template>
  <b-button
    class="btn-shift-data ml-2"
  >
    <font-awesome-icon
      icon="download"
      class="icon-style"
    />
    <slot/>
  </b-button>
</template>


<script>
export default {
  name: 'BtnDownload',
};
</script>

<style scoped>
.icon-style {
  color: #0bb0be;
  vertical-align: text-top;
  padding-right: 5px;
}
</style>